const swiperNews = new Swiper('.news__slider', {
    loop: true,
    spaceBetween: 0,
    slidesPerView: 'auto',
    speed: 800,
    watchSlidesProgress: true,
    pagination: {
      el: ".news__slider-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".news__slider-next",
      prevEl: ".news__slider-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
    autoplay: {
      delay: 3000, 
      disableOnInteraction: false,
    },
});

const swiperNewsUpdates = new Swiper('.news__updates', {
    loop: true,
    spaceBetween: 0,
    slidesPerView: 'auto',
    speed: 800,
    watchSlidesProgress: true,
    pagination: {
      el: ".news__updates-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".news__updates-next",
      prevEl: ".news__updates-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
    autoplay: {
      delay: 3000, 
      disableOnInteraction: false,
    },
});

const swiperNewsStrategies = new Swiper('.news__strategies', {
    loop: true,
    spaceBetween: 0,
    slidesPerView: 'auto',
    speed: 800,
    watchSlidesProgress: true,
    pagination: {
      el: ".news__strategies-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".news__strategies-next",
      prevEl: ".news__strategies-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
    autoplay: {
      delay: 3000, 
      disableOnInteraction: false,
    },
});

let swiperNewsSteps = null;

function initNewsStepsSwiper() {
  if (window.innerWidth < 992 && !swiperNewsSteps) {
    swiperNewsSteps = new Swiper('.news__steps__slider', {
      loop: true,
      spaceBetween: 0,
      slidesPerView: 'auto',
      speed: 800,
      watchSlidesProgress: true,
      pagination: {
        el: ".news__steps__slider-pagination",
        clickable: true,
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
  } else if (window.innerWidth >= 992 && swiperNewsSteps) {
    swiperNewsSteps.destroy(true, true);
    swiperNewsSteps = null;
  }
}

initNewsStepsSwiper();
window.addEventListener('resize', initNewsStepsSwiper);

const swiperNewsBlog = new Swiper('.news__blog', {
    loop: false,
    spaceBetween: 0,
    slidesPerView: 'auto',
    speed: 800,
    watchSlidesProgress: true,
    pagination: {
      el: ".news__blog-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".news__blog-next",
      prevEl: ".news__blog-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
    autoplay: {
      delay: 3000, 
      disableOnInteraction: false,
    },
});

const newsCaseButton = document.querySelector('.news__case__tag__button');

if (newsCaseButton) {
  newsCaseButton.addEventListener('click', () => {
      document.querySelector('.news__case__tag').classList.toggle('active');
  });
}

if (document.querySelector('.news__block')) {
  document.querySelectorAll('.news__block').forEach((sliderEl) => {
    new Swiper(sliderEl.querySelector('.swiper'), {
      loop: false,
      spaceBetween: 0,
      slidesPerView: 'auto',
      speed: 800,
      watchSlidesProgress: true,
      breakpoints: {
        992: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
      pagination: {
        el: ".news__block__slider-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: sliderEl.querySelector('.swiper-next'),
        prevEl: sliderEl.querySelector('.swiper-prev'),
      },
      autoplay: {
        delay: 3000, 
        disableOnInteraction: false,
      },
    });
  });
}

